import { Getter } from "vuex";
import { IState } from './state';

const selectedKeywords: Getter<IState, IState> = state => state.keywords.filter(keyword => keyword.selected).map(keyword => keyword.name);

export default {
	selectedKeywords
}
